import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

import { Company } from "../service";
import { clientStorage } from "./dummyEngine";

export type CommonStore = {
  company?: Company;
  setCompany: (company?: Company) => void;
  location?: string;
  setLocation: (location?: string) => void;
  foodLocation?: string;
  setFoodLocation: (location?: string) => void;
  shiftLocation?: string;
  setShiftLocation: (location?: string) => void;
  clear: () => void;
};

export const useCommonStore = create<CommonStore>()(
  persist(
    (set) => ({
      company: undefined,
      setCompany: (company) => set({ company }),
      location: undefined,
      setLocation: (location) => set({ location }),
      foodLocation: undefined,
      setFoodLocation: (foodLocation) => set({ foodLocation }),
      shiftLocation: undefined,
      setShiftLocation: (shiftLocation) => set({ shiftLocation }),
      clear: () =>
        set({
          company: undefined,
          location: undefined,
          shiftLocation: undefined,
          foodLocation: undefined,
        }),
    }),
    {
      name: "settings-store",
      storage: createJSONStorage(() => clientStorage),
    },
  ),
);
